import Symbol2d from '../2d.js'

export default class Ellipse extends Symbol2d {

  path (dimensions, handles) {
    const radii = this.radii(dimensions)

    // d3's path is a little weird and the `arcTo` method doesn't support
    // using different radiuses for x and y. So we'll just use the SVG
    // elliptical arc command instead.
    return `
      M ${radii[0]}, 0
      A ${radii[0]},${radii[1]},0,0,1,${radii[0]},${dimensions.height}
      A ${radii[0]},${radii[1]},0,0,1,${radii[0]},0
      Z
    `.replace(/\s+/g, '').trim()
  }

  radii (dimensions) {
    return [dimensions.width / 2, dimensions.height / 2]
  }

  textContainer (dimensions) {
    const radii = this.radii(dimensions)

    // Calculate the sides of the largest rectangle contained within the ellipse
    // The rectangle's sides are scaled by sqrt(2) due to the diagonal fitting
    const width = radii[0] * Math.sqrt(2)
    const height = radii[1] * Math.sqrt(2)

    return {
      width: width,
      height: height,
      center: dimensions.center
    }
  }

}
